import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./navbar.css";
import CompanyLogo from "../../Assets/Images/company_logo.png";
import CartIcon from "../CartComs/CartIcon";
import UserIcon from "../../Assets/Icons/UserIcon";
import HamburgerIcon from "../../Assets/Icons/HamburgerIcon";
import { useLogin } from "../../APIContext/LoginContext";
import { Menubar } from "primereact/menubar";
import { Sidebar } from "primereact/sidebar";
import NotificationBell from "../Notification/NotificationBell";
import { useNewUser } from "../../APIContext/NewUserContext";
import { useLogout } from "../../APIContext/UseLogout";

const NavbarCustom = () => {
  const logout = useLogout();
  const { fetchCartCount, cartRe } = useNewUser();
  const { user } = useLogin();
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("user"));

  const type_selfpay = userDetails ? userDetails.is_self_pay : null;

  // Menu items when NOT logged in
  const menuItemsGuestMobile = [
    {
      label: "Home",
      template: () => (
        <Link to="/" onClick={() => setSidebarVisible(false)}>
          Home
        </Link>
      ),
    },
    {
      label: "Buy Packages",
      template: () => (
        <Link to="/buy-packages" onClick={() => setSidebarVisible(false)}>
          Buy Packages
        </Link>
      ),
    },
    {
      label: "Instruction",
      template: () => (
        <Link to="/instruction" onClick={() => setSidebarVisible(false)}>
          Instruction
        </Link>
      ),
    },
    {
      label: "Coaches",
      template: () => (
        <Link to="/coaches" onClick={() => setSidebarVisible(false)}>
          Coaches
        </Link>
      ),
    },
    {
      label: "Careers",
      template: () => (
        <Link to="/careers" onClick={() => setSidebarVisible(false)}>
          Careers
        </Link>
      ),
    },
    {
      label: "Contact Us",
      template: () => (
        <Link to="/contact-us" onClick={() => setSidebarVisible(false)}>
          Contact Us
        </Link>
      ),
    },
    {
      label: "Log Out",
      // Use a functional template for the Logout button
      template: () => (
        <Link to="/login" onClick={() => setSidebarVisible(false)}>
          Sign Up / Login
        </Link>
      ),
    },
  ];

  // Menu items when NOT logged in
  const menuItemsGuestDesktop = [
    {
      label: "Home",
      template: () => (
        <Link to="/" onClick={() => setSidebarVisible(false)}>
          Home
        </Link>
      ),
    },
    {
      label: "Buy Packages",
      template: () => (
        <Link to="/buy-packages" onClick={() => setSidebarVisible(false)}>
          Buy Packages
        </Link>
      ),
    },
    {
      label: "Instruction",
      template: () => (
        <Link to="/instruction" onClick={() => setSidebarVisible(false)}>
          Instruction
        </Link>
      ),
    },
    {
      label: "Coaches",
      template: () => (
        <Link to="/coaches" onClick={() => setSidebarVisible(false)}>
          Coaches
        </Link>
      ),
    },
    {
      label: "Careers",
      template: () => (
        <Link to="/careers" onClick={() => setSidebarVisible(false)}>
          Careers
        </Link>
      ),
    },
    {
      label: "Contact Us",
      template: () => (
        <Link to="/contact-us" onClick={() => setSidebarVisible(false)}>
          Contact Us
        </Link>
      ),
    },
  ];

  // Menu items when logged in
  const menuItemsUserDesktop = [
    {
      label: "Home",
      template: () => (
        <Link to="/" onClick={() => setSidebarVisible(false)}>
          Home
        </Link>
      ),
    },
    // { label: "Dashboard", template: () => <Link to="/dashboard" onClick={() => setSidebarVisible(false)}>Dashboard</Link> },
    // { label: "Coaches", template: () => <Link to="/coaches" onClick={() => setSidebarVisible(false)}>Coaches</Link> },
    {
      label: "My Sessions",
      items: [
        {
          label: "Schedule Sessions",
          template: () => (
            <Link
              to={type_selfpay ? "/session-sports?type=1-1" : "/list-of-sports"}
              onClick={() => setSidebarVisible(false)}
            >
              Schedule Sessions
            </Link>
          ),
        },
        {
          label: "View All Sessions",
          template: () => (
            <Link
              to="/view-all-sessions"
              onClick={() => setSidebarVisible(false)}
            >
              View All Sessions
            </Link>
          ),
        },
      ],
    },
    ...(type_selfpay
      ? [
          {
            label: "Buy Packages",
            template: () => (
              <Link to="/buy-packages" onClick={() => setSidebarVisible(false)}>
                Buy Packages
              </Link>
            ),
          },
        ]
      : []),
    {
      label: "Instruction",
      template: () => (
        <Link to="/instruction" onClick={() => setSidebarVisible(false)}>
          Instruction
        </Link>
      ),
    },
    {
      label: "Coaches",
      template: () => (
        <Link to="/coaches" onClick={() => setSidebarVisible(false)}>
          Coaches
        </Link>
      ),
    },
    // {
    //   label: "Special Programs",
    //   items: [
    //     { label: "Field Days", template: () => <Link to="/field-days" onClick={() => setSidebarVisible(false)}>Field Days</Link> },
    //     { label: "School Programs", template: () => <Link to="/school-programs" onClick={() => setSidebarVisible(false)}>School Programs</Link> },
    //     { label: "After School Programs", template: () => <Link to="/after-school-programs" onClick={() => setSidebarVisible(false)}>After School Programs</Link> },
    //     { label: "Summer Camp", template: () => <Link to="/summer-camp" onClick={() => setSidebarVisible(false)}>Summer Camp</Link> },
    //     { label: "Birthday Parties", template: () => <Link to="/birth-day-parties" onClick={() => setSidebarVisible(false)}>Birthday Parties</Link> },
    //     { label: "Fundraising", template: () => <Link to="/fundraising" onClick={() => setSidebarVisible(false)}>Fundraising</Link> },
    //   ],
    // },
    {
      label: "Careers",
      template: () => (
        <Link to="/careers" onClick={() => setSidebarVisible(false)}>
          Careers
        </Link>
      ),
    },
    {
      label: "Contact Us",
      template: () => (
        <Link to="/contact-us" onClick={() => setSidebarVisible(false)}>
          Contact Us
        </Link>
      ),
    },
  ];

  // Menu items when logged in
  const menuItemsUserMobile = [
    {
      label: "Home",
      template: () => (
        <Link to="/" onClick={() => setSidebarVisible(false)}>
          Home
        </Link>
      ),
    },
    // { label: "Dashboard", template: () => <Link to="/dashboard" onClick={() => setSidebarVisible(false)}>Dashboard</Link> },
    // { label: "Coaches", template: () => <Link to="/coaches" onClick={() => setSidebarVisible(false)}>Coaches</Link> },
    {
      label: "My Sessions",
      items: [
        {
          label: "Schedule Sessions",
          template: () => (
            <Link
              to={type_selfpay ? "/session-sports?type=1-1" : "/list-of-sports"}
              onClick={() => setSidebarVisible(false)}
            >
              Schedule Sessions
            </Link>
          ),
        },
        {
          label: "View All Sessions",
          template: () => (
            <Link
              to="/view-all-sessions"
              onClick={() => setSidebarVisible(false)}
            >
              View All Sessions
            </Link>
          ),
        },
      ],
    },
    ...(type_selfpay
      ? [
          {
            label: "Buy Packages",
            template: () => (
              <Link to="/buy-packages" onClick={() => setSidebarVisible(false)}>
                Buy Packages
              </Link>
            ),
          },
        ]
      : []),
    {
      label: "Instruction",
      template: () => (
        <Link to="/instruction" onClick={() => setSidebarVisible(false)}>
          Instruction
        </Link>
      ),
    },
    {
      label: "Coaches",
      template: () => (
        <Link to="/coaches" onClick={() => setSidebarVisible(false)}>
          Coaches
        </Link>
      ),
    },
    {
      label: "Careers",
      template: () => (
        <Link to="/careers" onClick={() => setSidebarVisible(false)}>
          Careers
        </Link>
      ),
    },
    {
      label: "Contact Us",
      template: () => (
        <Link to="/contact-us" onClick={() => setSidebarVisible(false)}>
          Contact Us
        </Link>
      ),
    },

    {
      label: "Profile",
      items: [
        {
          label: "My Profile",
          template: () => (
            <Link to="/profile" onClick={() => setSidebarVisible(false)}>
              Profile
            </Link>
          ),
        },
        {
          label: "Your Players",
          template: () => (
            <Link to="/your-players" onClick={() => setSidebarVisible(false)}>
              Your Players
            </Link>
          ),
        },
        {
          label: "Saved Payment Method",
          template: () => (
            <Link
              to="/saved-payment-method"
              onClick={() => setSidebarVisible(false)}
            >
              Saved Payment Method
            </Link>
          ),
        },
        ...(type_selfpay
          ? [
              {
                label: "My Payment Details",
                template: () => (
                  <Link
                    to="/my-payment-details"
                    onClick={() => setSidebarVisible(false)}
                  >
                    My Payment Details
                  </Link>
                ),
              },
            ]
          : []),

        {
          label: "View All Sessions",
          template: () => (
            <Link
              to="/view-all-sessions"
              onClick={() => setSidebarVisible(false)}
            >
              View All Sessions
            </Link>
          ),
        },
        ...(type_selfpay
          ? [
              {
                label: "My Packages & Plans",
                template: () => (
                  <Link
                    to="/my-package-plans"
                    onClick={() => setSidebarVisible(false)}
                  >
                    My Packages & Plans
                  </Link>
                ),
              },
            ]
          : []),
        {
          label: "Notifications",
          template: () => (
            <Link to="/notifications" onClick={() => setSidebarVisible(false)}>
              Notifications
            </Link>
          ),
        },
        {
          label: "Change Password",
          template: () => (
            <Link
              to="/change-password"
              onClick={() => setSidebarVisible(false)}
            >
              Change Password
            </Link>
          ),
        },
      ],
    },
    {
      label: "Log Out",
      template: () => (
        <span onClick={logout} style={{ cursor: "pointer" }}>
          Log Out
        </span>
      ),
    },
  ];

  // Logo
  const start = (
    <Link to="/" onClick={() => setSidebarVisible(false)}>
      <img src={CompanyLogo} alt="Logo" className="navbar-logo" />
    </Link>
  );

  // Right side (login button or icons + hamburger)
  const mobileEnd = !user ? (
    <div className="navbar-icons">
      <Link
        to="/cart"
        className="nav-icon cart-icon-a"
        onClick={() => setSidebarVisible(false)}
      >
        <CartIcon className="nav-icon" count={cartRe} />
      </Link>

      <button
        className="nav-icon hamburger-icon"
        onClick={() => setSidebarVisible(true)}
      >
        <HamburgerIcon />
      </button>
    </div>
  ) : (
    <div className="navbar-icons">
      {type_selfpay === true && (
        <Link
          to="/cart"
          className="nav-icon cart-icon-a"
          onClick={() => setSidebarVisible(false)}
        >
          <CartIcon className="nav-icon" count={cartRe} />
        </Link>
      )}

      <NotificationBell />

      {/* <CartIcon className="nav-icon" /> */}
      <Link
        to="/profile"
        className="nav-icon profile-icon"
        onClick={() => setSidebarVisible(false)}
      >
        <UserIcon className="nav-icon" />
      </Link>
      <button
        className="nav-icon hamburger-icon"
        onClick={() => setSidebarVisible(true)}
      >
        <HamburgerIcon />
      </button>
    </div>
  );

  // Right side (login button or icons + hamburger)
  const deskEnd = !user ? (
    <div className="navbar-icons">
      <Link
        to="/cart"
        className="nav-icon cart-icon-a"
        onClick={() => setSidebarVisible(false)}
      >
        <CartIcon className="nav-icon" count={cartRe} />
      </Link>
      <Link
        to="/login"
        className="register-login-btn"
        onClick={() => setSidebarVisible(false)}
      >
        Sign Up / Login
      </Link>
    </div>
  ) : (
    <div className="navbar-icons">
      <NotificationBell />
      {type_selfpay === true && (
        <Link
          to="/cart"
          className="nav-icon cart-icon-a"
          onClick={() => setSidebarVisible(false)}
        >
          <CartIcon className="nav-icon" count={cartRe} />
        </Link>
      )}

      {/* <CartIcon className="nav-icon" /> */}
      <Link
        to="/profile"
        className="nav-icon"
        onClick={() => setSidebarVisible(false)}
      >
        <UserIcon className="nav-icon" />
      </Link>
    </div>
  );

  return (
    <nav className="navbar-container">
      {/* Desktop Navbar */}
      <div className="desktop-navbar">
        <Menubar
          model={user ? menuItemsUserDesktop : menuItemsGuestDesktop}
          start={start}
          end={deskEnd}
          className={user ? "login-menubar" : "not-login-menubar"}
        />
      </div>

      <div className="mobile-header-bar">
        {start}
        {mobileEnd}
      </div>

      {/* Sidebar / Offcanvas for Mobile/Tablet */}
      <Sidebar
        visible={sidebarVisible}
        position="right"
        onHide={() => setSidebarVisible(false)}
        className="mobile-sidebar"
      >
        <div className="mobile-sidebar-header">
          {start}
          <button
            className="close-btn"
            onClick={() => setSidebarVisible(false)}
          >
            ✕
          </button>
        </div>

        <Menubar
          model={user ? menuItemsUserMobile : menuItemsGuestMobile}
          className={user ? "login-menubar" : "not-login-menubar"}
        />
      </Sidebar>
    </nav>
  );
};

export default NavbarCustom;
